/** Kinetiq kHYPE — withdrawal enumeration on the StakingManager
 *  (Diamond proxy `0x393D0B87Ed38fc779FD9611144aE649BA6082109`,
 *  HyperEVM 999, VERIFIED via Sourcify facets).
 *
 *  Per-user ids run `0 .. nextWithdrawalId(user)-1`;
 *  `withdrawalRequests(user, id)` returns the request struct;
 *  `withdrawalDelay()` is the seconds before `confirmWithdrawal` works.
 *  A confirmed/cleared request returns `hypeAmount == 0`. */
export const KinetiqWithdrawalAbi = [
  {
    name: 'nextWithdrawalId',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'user' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'withdrawalDelay',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'withdrawalRequests',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'user' },
      { type: 'uint256', name: 'id' },
    ],
    outputs: [
      {
        type: 'tuple',
        components: [
          { name: 'hypeAmount', type: 'uint256' },
          { name: 'kHYPEAmount', type: 'uint256' },
          { name: 'kHYPEFee', type: 'uint256' },
          { name: 'bufferUsed', type: 'uint256' },
          { name: 'timestamp', type: 'uint256' },
        ],
      },
    ],
  },
] as const
